import { render, staticRenderFns } from "./WorldSection.vue?vue&type=template&id=5f1bf255"
import script from "./WorldSection.vue?vue&type=script&lang=js"
export * from "./WorldSection.vue?vue&type=script&lang=js"
import style0 from "./WorldSection.vue?vue&type=style&index=0&id=5f1bf255&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports